import { copyTextToClipboard, openLink, openTelegramLink, switchInlineQuery } from '@tma.js/sdk-react'

/**
 * Внешняя ссылка — только через SDK, не `window.open`: иначе в WebView она
 * откроется внутри Mini App и уведёт человека из Telegram без пути назад.
 */
export const openExternalLink = (url: string): void => {
  const result = openLink.ifAvailable(url)

  if (!result.ok) {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}

/** Ссылка `t.me/...` — открывается внутри Telegram, без браузера. */
export const openTelegramUrl = (url: string): void => {
  const result = openTelegramLink.ifAvailable(url)

  if (!result.ok) {
    window.open(url, '_blank', 'noopener,noreferrer')
  }
}

/** Домены, которые `openTelegramLink` принимает (проверка в самом SDK). */
const TELEGRAM_HOSTS: ReadonlySet<string> = new Set(['t.me', 'telegram.me', 'telegram.dog'])

const isTelegramUrl = (url: string): boolean => {
  try {
    return TELEGRAM_HOSTS.has(new URL(url).hostname)
  } catch {
    return false
  }
}

/**
 * Ссылка, вид которой заранее неизвестен (`VITE_SUPPORT_URL` и подобные):
 * `t.me/...` — внутри Telegram, без браузера, остальное — через `openLink`.
 * Поддержка чаще всего живёт в Telegram, и уводить человека в браузер ради
 * чата с оператором незачем.
 */
export const openUrl = (url: string): void => {
  if (isTelegramUrl(url)) {
    openTelegramUrl(url)
  } else {
    openExternalLink(url)
  }
}

/**
 * Вручение подарка: Telegram сам открывает выбор чата и подставляет
 * `@бот` в поле ввода. Главный механизм обучения inline (Р-14).
 *
 * Возвращает `false`, если клиент этого не умеет, — тогда остаётся
 * текстовая инструкция на экране.
 */
export const sendGiftInline = (): boolean => switchInlineQuery.ifAvailable('', ['users', 'groups']).ok

/** Копирование через SDK с откатом на Clipboard API. */
export const copyText = async (text: string): Promise<void> => {
  try {
    await copyTextToClipboard(text)
  } catch {
    await navigator.clipboard.writeText(text)
  }
}

/**
 * Позвонить: `tel:`-ссылка нажатием на невидимый `<a>` — `openLink` Telegram
 * открывает только `http(s)`, а переход по `tel:` клиент отдаёт системной звонилке.
 */
export const dialPhone = (telUrl: string): void => {
  const anchor = document.createElement('a')

  anchor.href = telUrl
  anchor.rel = 'noopener'
  anchor.click()
}
